export default "__VITE_ASSET__FpVxC2jI__"